import React, { Component } from 'react'
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { Button } from '@progress/kendo-react-buttons'
import Axios from 'axios';
import Config from '../Constants'
import {Redirect,Link} from 'react-router-dom'

export default class NewsUploadImage1 extends Component {

  constructor(props) {
    super(props)
    this.upload = this.upload.bind(this);
    this._crop = this._crop.bind(this);
    this.change = this.change.bind(this);
    this.previous = this.previous.bind(this);

    let id = this.props.match.params.Id;
    this.state = { ImageData: '',
                   ImageUrl: Config.API_URL + 'news/GetImage1/?id=' + id, 
                   Id:id,
                   isRedirectToNewsAdd:false}
  }

  _crop() {
    // image in dataUrl
    //this.setState({ImageData:this.refs.cropper.getCroppedCanvas().toDataURL()
    // })
    // console.log(this.refs.cropper.getCroppedCanvas().toDataURL());
  }

  upload() {
    Axios.post(Config.API_URL + 'news/uploadImage1',
     {Id:this.state.Id,Base64image: this.refs.cropper
      .getCroppedCanvas({ width: Config.NEWS_UPLOAD_IMAGE1_WITDTH, height: Config.NEWS_UPLOAD_IMAGE1_HEIGHT }).toDataURL() },
     {headers:{token: window.localStorage.getItem("apiToken")}}
     )     
    .then(response=>{
      this.setState({isRedirectToUploadThumb1:true});
      window.console.log(response);
    })
  }

  change(e) {

    var file = e.target.files[0];
    // var files = this.files;
    // var file;
    /*
        if (cropper && files && files.length) {
          //file = files[0];
    
          if (/^image\/\w+/.test(file.type)) {
            uploadedImageType = file.type;
            uploadedImageName = file.name;
    
            if (uploadedImageURL) {
              URL.revokeObjectURL(uploadedImageURL);
            }
    
            image.src = uploadedImageURL = URL.createObjectURL(file);
            cropper.destroy();
            cropper = new Cropper(image, options);
            inputImage.value = null;
          } else {
            window.alert('Please choose an image file.');
          }
        }*/

    debugger;
    window.foo = e;
    //let path = e.currentTarget.value;
    let path = URL.createObjectURL(file);

    this.setState({ ImageUrl: path });
    //this.setState({ImageUrl: 'https://picsum.photos/100/400'});

  }

  previous(){
    this.setState({isRedirectToNewsAdd:true});
  }

  render() {
    if (this.state.isRedirectToNewsAdd)
      return (<Redirect to={"/News/Edit/" + this.state.Id} />)

    if (this.state.isRedirectToUploadThumb1)
      return (<Redirect to={"/News/UploadThumb1/" + this.state.Id}/>)

    return (
      <div>
        <div id="page-wrapper">
          <div className="row">
            <div className="col-lg-12">

              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/">صفحه اصلی</Link></li>
                  <li className="breadcrumb-item"><Link to="/news">اخبار واطلاعیه ها</Link></li>
                  <li className="breadcrumb-item"><Link to={"/news/edit/" + this.state.Id}>ویرایش خبر</Link></li>

                  <li className="breadcrumb-item active" aria-current="page">تصویر خبر</li>                  
                </ol>
              </nav>
              <Cropper
                ref='cropper'
                src={this.state.ImageUrl}
                style={{ height: 400, width: '100%' }}
                // Cropper.js options
                aspectRatio={Config.NEWS_UPLOAD_IMAGE1_WITDTH / Config.NEWS_UPLOAD_IMAGE1_HEIGHT}
                width={100}
                guides={false}
                crop={this._crop.bind(this)}
                autoCrop={true}
                autoCropArea={1}

              />
              {/* <Button title="آپلود" onClick={this.change} >عکس</Button> */}
              <p>بهترین سایز{Config.NEWS_UPLOAD_IMAGE1_WITDTH} در {Config.NEWS_UPLOAD_IMAGE1_HEIGHT}</p>
              <input id="fileUpload" type="file" onChange={this.change} ></input>
              <div class="from-group" style={{ 'padding-top': '10px' }}>
                <button type="button" class="btn btn-primary" onClick={this.upload}>
                  تایید و ادامه
				          </button>
                <button type="button" class="btn btn-secondary" style={{ 'margin-right': '5px' }} onClick={this.previous}>
                  مرحله قبل
				          </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}
